import { requester } from "App";
import Dummy from "components/Dummy";
import P from "components/P";
import BackButton from "components/buttons/BackButton";
import CustomButton from "components/buttons/CustomButton";
import InputText from "components/inputs/signUp/InputText";
import Inline from "layouts/container/Inline";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import VerticalFlex from "layouts/flex/VerticalFlex";
import Center from "layouts/wrapper/Center";
import { useContext, useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import style from "./PointRecharge.module.css";
import { loadTossPayments } from "@tosspayments/payment-sdk";
import { AuthContext } from "providers/AuthProvider";

function MobileSignUp(props) {
    const { id } = useParams();
    const {userName} = useContext(AuthContext);

    const inputRef = useRef();
    const btnStyle = {
        backgroundColor: "var(--main-color)",
        border: "none",
        height: "50px",
        width: "90%",


    }
    const [isMounted, setMounted] = useState(false);
    const [point, setPoint] = useState(0);

    useEffect(() => {
        setMounted(true);

    }, [])
    useEffect(() => {
        if (isMounted) {
            let data = {}
            requester.findMemberPointById(data, (result) => {
                setPoint(result.data.point);
            })
        }

    }, [isMounted])
    const addPointClick = (value) => {
        const currentValue = parseInt(inputRef.current.getValue(), 10) || 0;
        


        const newValue = currentValue + value; // 숫자 덧셈
        inputRef.current.setValue(newValue);
        
    }
    const onRechargeClick = async () => {
        const tossPayments = await loadTossPayments('test_ck_YZ1aOwX7K8mdPGEkP9qryQxzvNPG');
        
        

        // requester.purchaseOrder를 프로미스로 감싸기
        const pointRechargeHistoryPromise = new Promise((resolve, reject) => {
            let data = {
                storeId: id,
                price: inputRef.current.getValue(),
                userName: userName,
            };
            requester.createPointRechargeHistory(data, (result) => {
                
                if (result.code === 0) {
                    resolve(result.data); // 성공 시 데이터 반환
                    
                } else {
                    reject(new Error('Purchase order failed')); // 실패 시 에러 반환
                }
            });
        });

        

        try {
            const resultData = await pointRechargeHistoryPromise; // 프로미스가 완료될 때까지 기다림
            
            const paymentData = {
                amount: inputRef.current.getValue(),
                orderId: resultData && resultData.id,
                orderName: "Puffu 포인트" + inputRef.current.getValue() + "원 충전",
                customerName: '홍길동',
                successUrl: `http://puffu.co.kr/ws/root/payment/gateway?type=point`,
                failUrl: "http://puffu.co.kr/ws/root/main",
            };
            tossPayments.requestPayment('CARD', paymentData);
        } catch (error) {
            console.error(error);
            // 에러 처리 로직
        }
    }

    return (

        <div style={{ position: "relative", height: "100vh" }}>
            <VerticalFlex gap={15}>
                <FlexChild width={"100%"} height={"initial"}>
                    <VerticalFlex>
                        <FlexChild padding={"10px 0"}>
                            <HorizontalFlex>
                                <FlexChild width={30}>
                                    <BackButton />
                                </FlexChild>
                                <FlexChild>
                                    <Center>
                                        <P size={20} color={"black"}>포인트 충전</P>
                                    </Center>
                                    <Dummy width={"30px"} />
                                </FlexChild>

                            </HorizontalFlex>

                        </FlexChild>
                        <FlexChild width={"100%"} height={"1px"} backgroundColor={"#D0D0D0"} />
                    </VerticalFlex>
                </FlexChild>
                <FlexChild width={"90%"} height={"initial"}>
                    <VerticalFlex>
                        <FlexChild>
                            <InputText ref={inputRef} numberOnly point gray mobileText placeHolder={"금액을 입력해주세요."} />
                        </FlexChild>
                    </VerticalFlex>
                </FlexChild>
                <FlexChild width={"90%"} height={"initial"}>
                    <Center width={"100%"} textAlign={"right"}>
                        <Inline>
                            <P>보유 포인트 : </P>
                            <P weight={"bold"} color={"var(--main-color)"}>{point && point} 원</P>
                        </Inline>
                    </Center>
                </FlexChild>
                <FlexChild width={"90%"} height={"initial"}>
                    <HorizontalFlex>
                        <FlexChild justifyContent={"center"}>
                            <P onClick={() => addPointClick(10000)} padding={"5px 12px"} border={"1px solid #D0D0D0"} borderRadius={"5px"}>+1만원</P>
                        </FlexChild>
                        <FlexChild justifyContent={"center"}>
                            <P onClick={() => addPointClick(30000)} padding={"5px 12px"} border={"1px solid #D0D0D0"} borderRadius={"5px"}>+3만원</P>
                        </FlexChild>
                        <FlexChild justifyContent={"center"}>
                            <P onClick={() => addPointClick(50000)} padding={"5px 12px"} border={"1px solid #D0D0D0"} borderRadius={"5px"}>+5만원</P>
                        </FlexChild>
                        <FlexChild justifyContent={"center"}>
                            <P onClick={() => addPointClick(100000)} padding={"5px 12px"} border={"1px solid #D0D0D0"} borderRadius={"5px"}>+10만원</P>
                        </FlexChild>
                    </HorizontalFlex>
                </FlexChild>

            </VerticalFlex>
            <div className={style.btnWrap}>
                <CustomButton onClick={onRechargeClick} text={"충전하기"} style={btnStyle} />
            </div>
        </div>


    );
}

export default MobileSignUp;